import React from 'react'
import { connect } from 'react-redux'
import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { classNamesK } from '../../lib/util'
import { getRealColor } from '../../lib/color'
import './Plate.scss'

const PlateBox = styled(Box)(
  ({ theme }) => `
  &.my-turn {
    background-color: ${theme.palette.player.myTurn2};
  }

  .chat-mark {
    color: ${theme.palette.player.chatMark};
  }

  .memo {
    color: ${theme.palette.player.memo};
  }
`
)

const Plate = ({ player, myTurn, selfID, users }) => {
  const user = users.get(player)
  const withMemo = user.memo !== ''

  const [nameMargin, setNameMargin] = React.useState(0)
  const [nameScale, setNameScale] = React.useState(1)
  const [memoMargin, setMemoMargin] = React.useState(0)
  const [memoScale, setMemoScale] = React.useState(1)

  const nameRef = React.useRef(null)
  const nameTextRef = React.useRef(null)
  const memoRef = React.useRef(null)
  const memoTextRef = React.useRef(null)

  React.useLayoutEffect(() => {
    const nbw = nameRef.current.getBoundingClientRect().width
    const ntw = nameTextRef.current.getBoundingClientRect().width
    setNameMargin(ntw > nbw ? 0 : (nbw - ntw) / 2)
    setNameScale(ntw > nbw ? nbw / ntw : 1)

    if (withMemo) {
      const mbw = memoRef.current.getBoundingClientRect().width
      const mtw = memoTextRef.current.getBoundingClientRect().width
      setMemoMargin(mtw > mbw ? 0 : (mbw - mtw) / 2)
      setMemoScale(mtw > mbw ? mbw / mtw : 1)
    }
  }, [user, withMemo])

  const name = (
    <Typography ref={nameRef}
                className={classNamesK('name', { self: selfID === player })}>
      <Box component="span" className="name-text"
           sx={{ marginLeft: `${nameMargin}px`, transform: `scaleX(${nameScale})` }}>
        <span className="chat-mark">
          {user.chatAnswer ? '©' : ''}
        </span>
        {user.name}
      </Box>
      <Box component="span" ref={nameTextRef} className="name-sample">
        <span className="chat-mark">
          {user.chatAnswer ? '©' : ''}
        </span>
        {user.name}
      </Box>
    </Typography>
  )

  const memo = (
    <Typography ref={memoRef} className="memo">
      <Box component="span" className="memo-text"
           sx={{ marginLeft: `${memoMargin}px`, transform: `scaleX(${memoScale})` }}>
        {user.memo}
      </Box>
      <Box component="span" ref={memoTextRef} className="memo-sample"
           sx={{ marginLeft: `${memoMargin}px`, transform: `scaleX(${memoScale})` }}>
        {user.memo}
      </Box>
    </Typography>
  )

  return (
    <Box className="plate">
      <PlateBox className={classNamesK('plate-box', { myTurn, withMemo })}
           sx={{ borderColor: getRealColor(user.color) }}>
        {withMemo && memo}
        {name}
      </PlateBox>
    </Box>
  )
}

export default connect(
  state => ({
    selfID: state.selfID,
    users: state.users
  })
)(Plate)
